export const settingsApiEndpoints = {
  getAdmins: (page: number, limit: number) =>
    `/admins?page=${page}&limit=${limit}`,
  createAdmin: `/admins`,
  updateAdmin: (id: string) => `/admins/${id}`,
  deleteAdmin: (id: string) => `/admins/${id}`,
};
